module.exports = __webpack_public_path__ + "img/202310_03.4d32994e.jpg";